import groq from 'groq';

export const tagsQuery = groq`
  title,
  "slug": slug.current
  `;
